
import CryptoJS from './AECwork';
const length=16;
if (length % 4 !== 0) {
    throw new Error('Length of the hex number must be a multiple of 4');
  }
  let hex = '';
  for (let i = 0; i < length / 4; i++) {
    hex += Math.floor(Math.random() * 0x10000).toString(16);
  }
const key=CryptoJS.enc.Utf8.parse(hex); //十六位十六进制数作为密钥
const iv=CryptoJS.enc.Utf8.parse(hex); //十六位十六进制数作为密钥偏移量
//解密方法
function decrypt(word) {
    let encryptedHexStr = CryptoJS.enc.Hex.parse(word);
    let srcs = CryptoJS.enc.Base64.stringify(encryptedHexStr);
    let decrypt = CryptoJS.AES.decrypt(srcs, key, { iv: iv, mode: CryptoJS.mode.CBC, padding: CryptoJS.pad.Pkcs7 });
    let decryptedStr = decrypt.toString(CryptoJS.enc.Utf8);
    return decryptedStr.toString();
}
//加密方法
function encrypt(word) {
    let srcs = CryptoJS.enc.Utf8.parse(word);
    let encrypted = CryptoJS.AES.encrypt(srcs, key, { iv: iv, mode: CryptoJS.mode.CBC, padding: CryptoJS.pad.Pkcs7 });
    return encrypted.ciphertext.toString();
}
export default {
    decrypt,
    encrypt
};
 
export{ decrypt, encrypt }